import React from "react";
import { BlueTickIcon, CorrectIcon, DisableCorrectIcon } from "../../icon";


interface IProps {
  passwordCheck: string;
  IsMobileDevice: boolean;
}

const PasswordRequirements: React.FunctionComponent<IProps> = (props) => {
  const hasNumber = () => {
    return new RegExp(/[0-9]/).test(props.passwordCheck);
  }
  const hasCapitlaletter = () => {
    return new RegExp(/[A-Z]/).test(props.passwordCheck);
  }
  const hasSmallletter = () => {
    return new RegExp(/[a-z]/).test(props.passwordCheck);
  }
  const hasSpecialCharacter = () => {
    return new RegExp(/[!~#@$%^&*`)(+=._-]/).test(props.passwordCheck);
  }
  const hasLength = () => {
    if (props.passwordCheck.length >= 8 && props.passwordCheck.length <= 20) {
      return true
    }
    return false
  }
  return (
    <div className={`d-flex flex-direction justify-between t-align-initial h6`}>
      <div className={` ${props.IsMobileDevice ? '' : ' mb-2'} color-changepassword-fields h4-medium`}> Password must contain the following:</div>
      <div className={`${props.IsMobileDevice ? "h4 d-flex color-changepassword-fields mt-1" : "h4-medium d-flex color-changepassword-fields-heading mt-2"}  align-center`}>
        {hasLength() ? <BlueTickIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`${props.IsMobileDevice ? 'my-auto' : ''} ${hasLength() ? "color-primary-light" : ""}`}>Should be between 8 to 20 characters</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4 d-flex color-changepassword-fields" : "h4-medium d-flex color-changepassword-fields-heading "}  mt-1 align-center`}>
        {hasCapitlaletter() ? <BlueTickIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`${hasCapitlaletter() ? "color-primary-light" : ""}`}>At least 1 capital letter</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4 d-flex color-changepassword-fields" : "h4-medium d-flex color-changepassword-fields-heading "}  mt-1 align-center`}>
        {hasSmallletter() ? <BlueTickIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`${hasSmallletter() ? "color-primary-light" : ""}`}>At least 1 small letter</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4 d-flex color-changepassword-fields" : "h4-medium d-flex color-changepassword-fields-heading "}  mt-1 align-center`}>
        {hasNumber() ? <BlueTickIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`${hasNumber() ? "color-primary-light" : ""}`}>At least 1 number</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4 d-flex color-color-changepassword-fields" : "h4-medium d-flex color-changepassword-fields-heading "}  mt-1 align-center`}>
        {hasSpecialCharacter() ? <BlueTickIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`my-auto ${hasSpecialCharacter() ? "color-primary-light" : ""} `}>At least 1 special character</span>
      </div>
    </div>
  )
}
export default PasswordRequirements
